export default {
    namespaced: true,

    state: () => {
        return {
            loading: false,
            designations: [],
        }
    },

    getters: {
        loading(state) {
            return state.loading;
        },

        designations(state) {
            return state.designations.map((item, sl) => {
                item.sl = sl + 1;
                return item;
            });
        }
    },

    mutations: {
        setLoading(state, loading) {
            state.loading = loading
        },

        setDesignation(state, designations) {
            state.designations = designations
        },
    },

    actions: {
        async getDesignations(context) {
            context.commit('setLoading', true);
        
            await axios.get(`${this.state.host}/get-designations`, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                context.commit('setDesignation', res.data.designations);
            })
            .catch(error => this.dispatch('snackbar/error', error))

            context.commit('setLoading', false);
        },

        async saveDesignation(context, payload) {
            let isSuccess = false;

            let url = '';
            if(payload.id != null) {
                url = 'update-designation';
            } else {
                url = 'add-designation';
                delete payload.id
            }

            await axios.post(`${this.state.host}/${url}`, payload, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getDesignations');
            })
            .catch(error => { 
                isSuccess = false;
                this.dispatch('snackbar/error', error);
            })

            return isSuccess;
        },

        async deleteDesignation(context, id) {
            let isSuccess = false;

            await axios.delete(`${this.state.host}/delete-designation/${id}`, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getDesignations');
            })
            .catch(error => { 
                isSuccess = false;
                this.dispatch('snackbar/error', error);
            })

            return isSuccess;
        }
    }
}
